import backofficeService from "../../api/backoffice"
import { brandRequestConfig } from "@/modules/Brand/requestBrand"

export default {
  /**
   * Submit the user data for sign up
   * @param {*} params Query Options
   */
  submit(data, currentBrand) {
    return backofficeService.Api().post("signup", data, brandRequestConfig(currentBrand))
      .then((response) => {
        localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, response.data.data)
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * Submit user token for verification
   * @param {*} params Query Options
   */
  verify(data) {
    return backofficeService.Api().post("signup/verifyEmail", data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Resubmit email
   * @param {*} params Query Options
   */
  resendVerifyEmail(data, currentBrand) {
    return backofficeService.Api().post("signup/resendVerification", data, brandRequestConfig(currentBrand))
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
